import styled from 'styled-components';

export const Wrapper = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black7};
  cursor: pointer;
`;
